import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { MySettingsModule } from "./my-settings/my-settings.module";
import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import { NotFoundComponent } from "./not-found.component";
import { AuthGuardService } from './my-settings/auth/AuthGuardService';
import { AuthService } from './my-settings/auth/AuthService';
import { MissingTranslationHandler, TranslateModule } from '@ngx-translate/core';
import { HttpModule } from '@angular/http';
import { NgxMissingHandler } from "./my-settings/shared/ngx-missing-handler";
import { NgxTranslateService } from "./my-settings/shared/ngx-translate.service";
import { WhiteLabelService } from "./my-settings/white-label/white-label.service";

@NgModule({
  imports: [
    MySettingsModule,
    BrowserModule,
    HttpModule,
    TranslateModule.forRoot({
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: NgxMissingHandler
      }
    }),
    // AppRouting should be the last import -- otherwise, routes in other modules
    // could be overridden.
    AppRoutingModule

  ],
  exports: [TranslateModule],
  declarations: [AppComponent, NotFoundComponent],
  providers: [AuthGuardService, AuthService, NgxTranslateService, WhiteLabelService],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class AppModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/app.module.ts